import type { Iso3166Alpha2, LocaleCode } from "../types";

import { deriveCountryCodes } from "./derive-country-codes";
import { parseLocaleCode } from "./parse-locale-code";

/** Sanity document and GROQ filters use ISO 3166-1 alpha-2 uppercase (`US`, `CA`). */
function getSanityDocumentCountryCode(code: LocaleCode): Iso3166Alpha2 {
  const { iso3166Alpha2Lower } = parseLocaleCode(code);
  return deriveCountryCodes(iso3166Alpha2Lower).iso3166Alpha2;
}

export { getSanityDocumentCountryCode };
